import { ChangeEvent, forwardRef } from 'react'

import { cva } from 'class-variance-authority'

import { mergeClassName } from '@erudilabs/merge-class-utils'

export interface ToogleProps {
  className?: string
  testId?: string
  id?: string
  name: string
  disabled?: boolean
  value?: string | boolean
  defaultChecked?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const toogle = cva([
  "h-6 w-[50px] peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full  after:content-[''] after:absolute after:top-0.5 after:left-[2.5px] after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-500 peer-checked:border-none border cursor-pointer peer-disabled:cursor-not-allowed  peer-checked:after:left-[7.5px]",
  'bg-gray-200 after:bg-white border-gray-300 after:border-gray-300 peer-disabled:peer-checked:bg-gray-300 peer-disabled:after:bg-gray-500',
  'dark:bg-gray-900 dark:border-gray-700 peer-disabled:dark:border-gray-800 peer-disabled:dark:bg-gray-800 peer-disabled:after:dark:bg-gray-700 peer-checked:after:dark:bg-gray-900 peer-disabled:peer-checked:after:dark:bg-gray-900 after:dark:bg-gray-700 after:dark:border-gray-800 peer-disabled:dark:peer-checked:bg-gray-800',
])

export const Toogle = forwardRef<HTMLInputElement, ToogleProps>(
  (props, ref) => {
    const {
      id,
      testId,
      className,
      disabled,
      name,
      value,
      onChange,
      defaultChecked,
    } = props

    return (
      <div data-testid={testId} className={mergeClassName(className)}>
        <label className="relative inline-flex items-center">
          <input
            id={id}
            ref={ref}
            type="checkbox"
            value={value as string}
            name={name}
            className="sr-only peer"
            disabled={disabled}
            defaultChecked={defaultChecked || (value as boolean)}
            onChange={onChange}
          />
          <div className={mergeClassName(toogle())} />
        </label>
      </div>
    )
  }
)
